import React from "react";
import { Route, Switch } from "react-router-dom";
import Add from "./Add";
import List from "./List";
import Summary from "./Summary";
import { Addresses } from "./addresses/Index";
import { StoreAddresses } from "./store-addresses/Index";
import { TiepDocuments } from "./tiep-documents/Index";

import AquaAdd from "./aqua/Add";
import AquaList from "./aqua/List";
import AquaSummary from "./aqua/Summary";

import { Auth } from "_helpers";

function Companies({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "AQUA") {
    return (
      <Switch>
        <Route exact path={path} component={AquaList} />
        <Route path={`${path}/add`} component={AquaAdd} />
        <Route path={`${path}/:id/summary`} component={AquaSummary} />
        <Route path={`${path}/:id/addresses`} component={Addresses} />
        <Route
          path={`${path}/:id/store-addresses`}
          component={StoreAddresses}
        />
        <Route path={`${path}/:id/document-upload`} component={TiepDocuments} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/:id/summary`} component={Summary} />
        <Route path={`${path}/:id/addresses`} component={Addresses} />
        <Route
          path={`${path}/:id/store-addresses`}
          component={StoreAddresses}
        />
        <Route path={`${path}/:id/document-upload`} component={TiepDocuments} />
      </Switch>
    );
  }
}

export { Companies };
